import type { LLMConfiguration } from '@/interfaces/llmConfiguration.interface';
import api from './base.api';

const BASE_PATH = '/llm';

export const getLLMConfiguration = async () => {
  const response = await api.get<LLMConfiguration>(
    `${BASE_PATH}/configuration`,
  );
  return response.data;
};
